export const CONFTYPE_SHOW_RESET = 'CONFTYPE_SHOW_RESET'
export const CONFTYPE_SHOW_SET_ERROR = 'CONFTYPE_SHOW_SET_ERROR'
export const CONFTYPE_SHOW_SET_RETRIEVED = 'CONFTYPE_SHOW_SET_RETRIEVED'
export const CONFTYPE_SHOW_TOGGLE_LOADING = 'CONFTYPE_SHOW_TOGGLE_LOADING'
